import React from 'react';
import { Container, Header, Divider } from 'semantic-ui-react';
class OVCstruct extends React.Component {
  render(){
    return <Container text textAlign='left'>
      <Header as='h3' textAlign='center'>
        Capital Structure
      </Header>
      <Divider />
      <p>
        Based in London, OVC was incorporated in the UK in January 2019. The company is a stock corporation.
        Working with investment managers in the US and Asia, it intends to launch special investment vehicles and to raise substantial capital
        from strategic investors including family wealth funds, government pension funds,
        endowments, foundations, and institutional investors.
      </p>
      <p>
        OVC enjoys good access to institutional investors, sovereign funds and high net-worth families. It
        presents investment opportunities to strategic investors directly. It may raise growth capital or
        launch new investment accounts/partnership funds, depending on investment opportunities. OVC provides
         necessary science and
        market knowledge to the portfolio companies in connection with product commercialization and
        business management in local markets.
      </p>
      <p>
        In special situations, OVC will also make investments in some of these startups.
      </p>
      <p>
        To assist and accelerate successful technology companies in product commercialization and
        fundraising in Greater China, OVC formed a new company with strategic science and business
        partners in Hong Kong in April 2019.
      </p>
    </Container>;
  }
}

export default OVCstruct;
